// Module
var code = "<kendo-grid id=\"rolesGrid\" k-scope-field=\"rolesGrid\" flowingly-grid grid-need-resize=\"$ctrl.gridNeedResize\" offset=\"300\" no-rows=\"$ctrl.noRows\" options=\"$ctrl.options\" class=\"runner-grid-default\"> </kendo-grid> ";
// Exports
export default code;